function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17 15a1 1 0 10-2 0v10a1 1 0 102 0V15zM21 14a1 1 0 011 1v10a1 1 0 11-2 0V15a1 1 0 011-1zM12 15a1 1 0 10-2 0v10a1 1 0 102 0V15z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.71 2.363a4.652 4.652 0 00-1.254 2.29H8.435A3.435 3.435 0 005 8.086v1.226H4a1 1 0 100 2h1.652v16.252A3.435 3.435 0 009.087 31h13.826a3.435 3.435 0 003.435-3.435V11.313H28a1 1 0 100-2h-1V8.087a3.435 3.435 0 00-3.435-3.435h-3.022a4.652 4.652 0 00-7.833-2.29zM16 3a2.652 2.652 0 00-2.457 1.652h4.913A2.652 2.652 0 0016 3zm7.565 3.652H8.435A1.435 1.435 0 007 8.087v1.226h18V8.087a1.435 1.435 0 00-1.435-1.435zM7.652 27.565V11.313h16.696v16.252A1.435 1.435 0 0122.913 29H9.087a1.435 1.435 0 01-1.435-1.435z",
  fill: "currentColor"
})));